import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { EndOfListContainer } from './styles';
const loadMoreButtonWrapperIsUpcomingCss = "l19odkyy";
const loadMoreButtonWrapperCss = "lxw77jm";
const LoadMoreButtonWrapper = forwardRef((props, ref) => {
  const {
    isUpcoming,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(loadMoreButtonWrapperCss, {
    [loadMoreButtonWrapperIsUpcomingCss]: isUpcoming
  }, props.className)} />;
});
const LoadMoreButton = ({
  isUpcoming,
  onClick,
  isLoading
}) => <LoadMoreButtonWrapper isUpcoming={isUpcoming}>
    <Button onClick={onClick} disabled={isLoading} decoration="secondary-outline" loading={isLoading}>
      {I18n.t('publisher.meetings.end_of_list.view_more')}
    </Button>
  </LoadMoreButtonWrapper>;
const TopMessage = () => <EndOfListContainer>
    <BodyText size="medium" color="muted">
      {I18n.t('publisher.meetings.end_of_list.no_past')}
    </BodyText>
  </EndOfListContainer>;
const BottomMessage = () => <EndOfListContainer>
    <BodyText size="medium" color="muted">
      {I18n.t('publisher.meetings.end_of_list.no_more_upcoming')}
    </BodyText>
  </EndOfListContainer>;
export const Bookend = ({
  hasMore,
  isUpcoming,
  anyFutureMeetings,
  ...props
}) => {
  if (!hasMore) {
    if (!isUpcoming) {
      return <TopMessage />;
    }
    if (anyFutureMeetings) {
      return <BottomMessage />;
    }
    return null;
  }
  return <LoadMoreButton isUpcoming={isUpcoming} {...props} />;
};

require("./bookend.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./bookend.js");